import { render, staticRenderFns } from "./PublishNotif.vue?vue&type=template&id=738e12b5&scoped=true&"
import script from "./PublishNotif.vue?vue&type=script&lang=js&"
export * from "./PublishNotif.vue?vue&type=script&lang=js&"
import style0 from "./PublishNotif.vue?vue&type=style&index=0&id=738e12b5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738e12b5",
  null
  
)

export default component.exports